// @ts-nocheck
import { useEffect } from "react";
import { formatCurrencyBRL, toNumber } from "../../../../../utils";
import "./TabelaValores.css";

const pegarParcelas = (TabelaReembolso) => {
  if (!TabelaReembolso) return [];
  if (Array.isArray(TabelaReembolso)) return TabelaReembolso;
  if (Array.isArray(TabelaReembolso.parcelas)) return TabelaReembolso.parcelas;
  if (Array.isArray(TabelaReembolso.Parcelas)) return TabelaReembolso.Parcelas;
  return [];
};

const pegarDespesas = (DadosDespesas) => {
  if (!DadosDespesas) return [];
  if (Array.isArray(DadosDespesas)) return DadosDespesas;
  if (Array.isArray(DadosDespesas.despesas)) return DadosDespesas.despesas;
  if (Array.isArray(DadosDespesas.Despesas)) return DadosDespesas.Despesas;
  return [];
};

const ordinalParcela = (n) => (n === 1 ? "1ª" : n === 2 ? "2ª" : `${n}ª`);
const norm = (s) =>
  String(s || "")
    .trim()
    .toLowerCase();

const isSelecionada = (p) => {
  const s = norm(p?.situacao);
  if (s === "solicitado" || s === "já solicitado") return false;
  if (s === "solicitando") return true;
  return p?.solicitar === true;
};

const TabelaValores = ({
  TabelaReembolso,
  DadosDespesas,
  liberarParcela = false,
  onTotalsChange,
}) => {
  const parcelas = pegarParcelas(TabelaReembolso);

  const selecionadas = parcelas.filter(isSelecionada);

  const tiposOrdenados = [
    ...new Set(selecionadas.map((p) => Number(p?.idTipoParcela))),
  ]
    .filter(Number.isFinite)
    .sort((a, b) => a - b);

  const somaParcelasSelecionadas = selecionadas.reduce(
    (acc, p) => acc + toNumber(p?.valor),
    0,
  );

  const despesas = pegarDespesas(DadosDespesas);
  const totalDespesas = despesas
    .filter((d) => d?.deletar !== true)
    .reduce((acc, d) => acc + toNumber(d?.valor), 0);

  const totalQueSeraApoiado = liberarParcela
    ? somaParcelasSelecionadas
    : Math.min(totalDespesas, somaParcelasSelecionadas);

  const valorSemComprovacao = Math.max(
    0,
    somaParcelasSelecionadas - totalDespesas,
  );

  useEffect(() => {
    onTotalsChange?.({
      somaParcelasSelecionadas,
      totalDespesas,
      valorSemComprovacao,
      totalQueSeraApoiado,
    });
  }, [
    somaParcelasSelecionadas,
    totalDespesas,
    valorSemComprovacao,
    totalQueSeraApoiado,
    onTotalsChange,
  ]);

  // Mesma Descrição da tabela "Informações completas para o reembolso".
  const labelDoTipo = (tipo) => {
    const row = selecionadas.find((p) => Number(p?.idTipoParcela) === tipo);
    const descricao = String(row?.descricao ?? "").trim();
    if (descricao) return descricao.toUpperCase();
    return `${ordinalParcela(tipo)} PARCELA`;
  };

  return (
    <div className="card shadow-sm p-4 mb-4">
      <h5 className="fw-bold text-uppercase mb-4">Valores</h5>

      <div className="table-responsive">
        <table className="table tabela-valores mb-0">
          <tbody>
            {tiposOrdenados.map((tipo) => {
              const totalTipo = selecionadas
                .filter((p) => Number(p?.idTipoParcela) === tipo)
                .reduce((sum, p) => sum + toNumber(p?.valor), 0);
              if (totalTipo <= 0) return null;
              return (
                <tr key={`parcela-${tipo}`}>
                  <td>{labelDoTipo(tipo)}</td>
                  <td>{formatCurrencyBRL(totalTipo)}</td>
                </tr>
              );
            })}

            <tr>
              <td>VALOR TOTAL DAS DESPESAS COMPROVADAS</td>
              <td>{formatCurrencyBRL(totalDespesas)}</td>
            </tr>
            <tr>
              <td>TOTAL QUE SERÁ APOIADO</td>
              <td>{formatCurrencyBRL(totalQueSeraApoiado)}</td>
            </tr>
            <tr>
              <td>VALOR SEM COMPROVAÇÃO</td>
              <td>{formatCurrencyBRL(valorSemComprovacao)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TabelaValores;
